"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardErrorEnum = void 0;
var CardErrorEnum;
(function (CardErrorEnum) {
    CardErrorEnum["UPGRADE_PHYSICAL_FAILED"] = "UPGRADE_PHYSICAL_FAILED";
    CardErrorEnum["TOP_UP_CARD_FAILED"] = "TOP_UP_CARD_FAILED";
    CardErrorEnum["ACTIVATION_FAILED"] = "ACTIVATION_FAILED";
    CardErrorEnum["SPENDING_CONTROLS_UPDATE_FAILED"] = "SPENDING_CONTROLS_UPDATE_FAILED";
})(CardErrorEnum || (exports.CardErrorEnum = CardErrorEnum = {}));
